<template>
    <div id="demo-basic-card">
        <div id="dashboard-analytics" class="margin-top">
            <div class="vx-row">
                <div class="vx-col md:w-7/12 w-full mt-2 p-0">
                    <div class="vx-card p-6">
                        <div class="component w-full pb-4 border-bottom-color">
                            <span class="font-medium text-title-package">KỲ THANH TOÁN</span>
                        </div>
                        <div class="component mt-4 w-full">
                            <span class="font-medium">{{ businessPackage.name || 'Chưa chọn gói' }} </span>
                            <a class="cursor-pointer" @click="changePackage">(đổi gói)</a>
                        </div>
                        <div class="vx-row mt-4 mb-4" v-for="(item, indexPackage) in optionalPackages" :key="indexPackage">
                            <div class="vx-col md:w-1/12 w-full m-auto">
                                <vs-radio v-model="item.selected" :vs-value="item.value" @change="selectedPackage(item)"></vs-radio>
                            </div>
                            <div class="vx-col md:w-11/12 w-full">
                                <vs-button type="border" class="w-full text-left" @click="selectedPackage(item)">
                                    <div class="vx-row">
                                        <div class="component w-full">
                                            <span class="font-medium text-title-package">{{ item.title }} </span>
                                            <span class="text-discount">{{ item.discount }}</span>
                                        </div>
                                        <div class="component w-full mt-2">
                                            <span class="text-content ">{{ item.content }}</span>
                                        </div>
                                    </div>
                                </vs-button>
                            </div>
                        </div>
                    </div>

                    <div class="vx-card p-6 mt-4">
                        <div class="component w-full pb-4 border-bottom-color">
                            <span class="font-medium text-title-package">THÔNG TIN THANH TOÁN</span>
                        </div>
                        <div class="vx-row mb-4">
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Chủ thể</label>
                                <v-select class="w-full" v-model="selectedSubjectType" :options="optionSubjectTypes" ></v-select>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Họ và tên</label>
                                <vs-input  v-model="user.fullName" class="w-full"></vs-input>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Tên công ty</label>
                                <vs-input v-model="user.organization.organizationName" class="w-full"></vs-input>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">MST</label>
                                <vs-input class="w-full"></vs-input>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Email</label>
                                <vs-input v-model="user.email" class="w-full"></vs-input>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Điện thoại</label>
                                <vs-input v-model="user.phoneNumber" class="w-full"></vs-input>
                            </div>
                            <div class="vx-col w-full mt-4">
                                <label for="" class="font-medium font-label">Số nhà, tên đường</label>
                                <vs-input v-model="user.fullAddress" class="w-full"></vs-input>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Tỉnh / Thành</label>
                                <v-select v-model="province" :options="cityOptions" class="w-full"></v-select>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <label for="" class="font-medium font-label">Quận / Huyện</label>
                                <v-select v-model="district" :options="districtOptions" class="w-full"></v-select>
                            </div>
                        </div>
                    </div>

                    <div class="vx-card p-6 mt-4">
                        <div class="component w-full pb-4 border-bottom-color">
                            <span class="font-medium text-title-package">HÌNH THỨC THANH TOÁN</span>
                        </div>
                        <div class="vx-row mt-6 mb-4" v-for="(item, indexPackage) in optionPayments" :key="indexPackage">
                            <div class="vx-col md:w-1/12 w-full m-auto">
                                <vs-radio v-model="item.selected" :vs-value="item.value" @change="selectedPaymentType(item)"></vs-radio>
                            </div>
                            <div class="vx-col md:w-11/12 w-full">
                                <vs-button type="border" class="w-full text-left" @click="selectedPaymentType(item)">
                                    <div class="vx-row">
                                        <div class="component w-full">
                                            <span class="text-title-package">{{ item.title }} </span>
                                            <span v-if="item.value == 1" class="text-danger">VN</span>
                                            <span v-if="item.value == 1" class="text-primary">PAY-</span>
                                            <span v-if="item.value == 1" class="text-danger">QR</span>
                                        </div>
                                    </div>
                                </vs-button>
                            </div>
                        </div>
                    </div>

                    <div class="vx-card p-6 mt-4">
                        <div class="component w-full pb-4 border-bottom-color">
                            <span class="font-medium text-title-package">BẠN CÓ MUỐN NHẬN TIN TỨC ƯU ĐÃI TỪ INFOCARE?</span>
                        </div>
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <span class="font-regular text-suggest">Chúng tôi mong muốn gửi cho bạn những thông tin hữu ích, khuyến mãi qua email. Đánh dấu vào ô bên dưới để đăng ký, bạn có thể huỷ đăng ký bất kỳ lúc nào.</span>
                            </div>
                        </div>
                        <div class="vx-row mt-6 mb-6">
                            <div class="vx-col w-full flex">
                                <span class="font-regulart text-suggest">Nhận email khuyến mãi</span>
                                <vs-switch v-model="invoice.allowNotify" class="ml-4"></vs-switch>
                            </div>
                        </div>
                    </div>

                   <div class="w-full mt-4">
                       <div class="vx-row">
                           <div class="vx-col md:w-1/12 w-full mt-4" style="min-width:65px">
                                <vs-checkbox v-model="invoice.acceptTerm"></vs-checkbox>
                           </div>
                           <div class="vx-col md:w-10/12 w-full mt-4">
                                <span class="font-regular text-suggest">Tôi đồng ý rằng InfoCare sẽ có quyền chấm dứt dịch vụ và huỷ toàn bộ dữ liệu khi vi phạm </span>
                                <span class="font-medium text-primary">Quy định sử dụng dịch vụ</span>
                           </div>
                       </div>
                   </div>

                   <div class="vx-card p-6 mt-6" style="background: rgb(254, 196, 0, .12); color:#FEC400;border: 1px solid #FEC400">
                       <div class="vx-row m-auto pt-6 pb-6">
                           <div class="vx-col w-full">
                               <span>Để đảm bảo tính hơp pháp của đơn hàng này, địa chỉ IP của khách hàng (192.168.1.1) sẽ được hệ thống lưu lại.</span>
                           </div>
                       </div>
                   </div>

                </div>
                <div class="vx-col md:w-5/12 w-full mt-2 pr-0">
                    <div class="vx-card bg-package p-6">
                        <div class="flex border-bottom-color w-full">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component w-full pb-4">
                                            <span class="sm:flex header-float m-auto font-medium ">THÔNG TIN ĐƠN HÀNG</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex border-bottom-color w-full mt-4">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component md:w-1/3 w-full">
                                            <span class="sm:flex header-float m-auto">Gói</span>
                                    </div>
                                    <div class="component md:w-2/3 w-full">
                                        <div class="component w-full">
                                            <span class="sm:flex header-float">{{ order.name }}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="font-regular">{{ order.time }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="vx-row ml-0 text-inline mt-4 pb-4">
                                    <div class="component md:w-1/3 w-full">
                                            <span class="sm:flex header-float m-auto ">Giá trị</span>
                                    </div>
                                    <div class="component md:w-2/3 w-full">
                                            <span class="sm:flex header-float"> {{ eArabic(order.price) || 0}}đ</span>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="flex border-bottom-color w-full mt-4">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component md:w-1/3 w-full">
                                            <span class="sm:flex header-float m-auto">Mã giảm giá</span>
                                    </div>
                                    <div class="component md:w-2/3 w-full pb-4">
                                            <span class="sm:flex header-float"> (0,00đ) </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex border-bottom-color w-full mt-4">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component md:w-1/3 w-full">
                                            <span class="sm:flex header-float m-auto">VAT @ 10,00%</span>
                                    </div>
                                    <div class="component md:w-2/3 w-full pb-4">
                                            <span class="sm:flex header-float"> {{ eArabic(order.VAT) || 0}} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex w-full mt-4">
                            <div class="w-full">
                                <div class="vx-row ml-0 text-inline">
                                    <div class="component md:w-1/3 w-full">
                                            <span class="sm:flex header-float m-auto ">Tổng</span>
                                    </div>
                                    <div class="component md:w-2/3 w-full pb-4">
                                            <span class="sm:flex header-float" style="color:#28C76F"> {{ eArabic(order.total) }} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <vs-button class="w-full mt-2 text-primary bg-white" @click="saveChanges">Tiếp tục</vs-button>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mt-4 text-center">
                            <span class="font-medium">Cần sự trợ giúp? </span>
                            <span class="font-medium text-primary cursor-pointer">Liên hệ với chúng tôi để được trợ giúp</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- popup selected package -->

        <div id="demo-basic-card" v-if="activePopupPackage" class="bg-business-package">
            <div id="dashboard-analytics">
                <div class="vx-row">
                    <div class="component vx-card md:w-7/12 mx-auto p-8">
                        <div class="component w-full pb-4 border-bottom-color">
                            <span class="font-medium text-contact">ĐỔI GÓI DỊCH VỤ</span>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full md:w-1/2 mt-2" v-for="(itemPackage, packageIndex) in businessPackages.slice(1, businessPackages.length)" :key="packageIndex">
                                <div class="component mt-4">
                                    <vs-button class="w-full text-left" type="border" style="border: 1px solid #82868b" @click="chosePackage(itemPackage)">
                                        <div class="vx-row">
                                            <div class="component w-full">
                                                <span class="font-bold text-suggest">{{ itemPackage.name }}</span>
                                            </div> 
                                            <div class="component w-full mt-2">
                                                <span class="font-regular text-content">{{ eArabic(itemPackage.price) }}/thang</span>
                                            </div>
                                        </div>
                                    </vs-button>
                                </div>
                            </div>
                            <div class="vx-col w-full mt-6 md:w-1/2">
                                <div class="component w-full">
                                    <span class="font-bold"> Liên hệ</span>
                                </div>
                                <div class="component w-full">
                                    <span class="text-contact">Vui lòng gọi tổng đài: 1800 2018 để được tư vấn gọi dịch vụ phù hợp</span>
                                </div>
                            </div>
                        </div>
                        <div class="vx-row mt-4 p-4">
                            <div class="w-full text-center">
                                <vs-button @click="selectedPopupPackage">Chọn</vs-button>
                                <vs-button color="danger" class="ml-4" type="border" @click="activePopupPackage = false">Đóng</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from "vue-select";
import province from '@/assets/utils/province.js';
export default {
    components: {
        vSelect
    },
    data(){
        return {
            selected: 1,
            optionalPackages: [
                {title: '12 tháng', discount: '(chiết khấu 10%)', content: '', value: 3, selected: false, price: ''},
                {title: '3 tháng', discount: '(chiết khấu 5%)', content: '', value:2, selected: false, price: ''},
                {title: '1 tháng', discount: '', content: '', value:1, selected: false, price: ''}
            ],
            optionPayments:[
                {title: 'Ứng dụng Mobile Banking quét mã', value: 1, selected: false},
                {title: 'Chuyển khoản', value: 2, selected:false}
            ],
            optionSubjectTypes: [
                {label: 'Cá nhân', value: 0},
                {label: 'Công ty', value: 1},
                {label: 'Doanh nghiệp', value: 2}
            ],
            businessPackages:[],
            businessPackage: {
                allowUserRegister: null,
                days: null,
                displayOrder: null,
                id: null,
                metaData:null,
                name: null,
                permissions: [],
                price: null,
                primaryPackage: null,
                totalData: null,
                totalKeyword: null,
                totalSubAccount: null,
                userId: null,
                bg: null
            },
            user: {
                fullName: null,
                subject: null,
                organization:{
                    organizationName: null
                },
                email: null,
                phoneNumber: null,
                fullAddress:null,
                district: null,
                city: null
            },
            invoice: {
                allowNotify: false,
                acceptTerm: false
            },
            order: {
                name: '',
                time: '',
                price: '',
                code: '',
                VAT: '',
                total: ''
            },

            activePopupPackage: false,

            valueSelectedPackage: null,
            valueSelectedPayment: null,
            valueSelectedSubject: null,

            cityOptions: province.getProvince(),
            districtOptions: province.getDistrict(),
            subDistrictOptions: province.getSubDistrict()
        }
    },
    computed:{
        selectedSubjectType:{
            get(){
                let object = this.optionSubjectTypes.find(subject => subject.value === this.valueSelectedSubject);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.valueSelectedSubject = object.value ? object.value : null;
            }
        },
        province: {
            get() {
                let obj = this.cityOptions.find(x => x.value === this.user.city);
                if (!obj) {
                return null;
                }
                return {
                label: obj.label,
                value: this.user.city
                }
            },
            set(obj) {
                this.user.city = obj.value;
                this.districtOptions = province.getDistrict(obj.value);
                this.user.district = this.districtOptions[0].value;
                this.subDistrictOptions = province.getSubDistrict(this.user.city, this.user.district);
                this.user.subDistrict = this.subDistrictOptions[0].value;
            }
        },
        district: {
            get() {
                let obj = this.districtOptions.find(x => x.value === this.user.district);
                if (!obj) {
                return null;
                }
                return {
                label: obj.label,
                value: this.user.district
                }
            },
            set(obj) {
                this.user.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.user.city, obj.value);
                this.user.subDistrict = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                let obj = this.subDistrictOptions.find(x => x.value === this.user.subDistrict);
                if (!obj) {
                return null;
                }
                return {
                label: obj.label,
                value: this.user.subDistrict
                }
            },
            set(obj) {
                this.user.subDistrict = obj.value
            }
        }
    },
    methods:{
        selectedPopupPackage: function(){
            this.activePopupPackage = false;
            let month = this.businessPackage.price;
            let year = (this.businessPackage.price - this.businessPackage.price * 0.1) * 12;
            let threeMonth = (this.businessPackage.price - this.businessPackage.price * 0.05) * 3;
            this.optionalPackages[0].content = this.eArabic(year/12) + "/tháng " + " " + this.eArabic(year) + "/năm"
            this.optionalPackages[1].content = this.eArabic(threeMonth/3) + "/tháng " + " " + this.eArabic(threeMonth) + "/năm"
            this.optionalPackages[2].content = this.eArabic(month) + "/tháng"
            this.optionalPackages[0].price = year;
            this.optionalPackages[1].price = threeMonth;
            this.optionalPackages[2].price = month;
            this.optionalPackages.map(el => {
                if (el.selected) this.orderPackage(el);
            })
        },
        changePackage: function(){
            this.activePopupPackage = true;
        },
        selectedPackage: function(item){
            this.optionalPackages.forEach(el  => el.selected = false);
            item.selected = item.value;
            this.valueSelectedPackage = item.value;
            this.orderPackage(item);
        },
        orderPackage: function(item){
            this.order.name = this.businessPackage.name;
            this.order.price = item.price;
            this.order.VAT = item.price * 0.1;
            this.order.total = this.order.price + this.order.VAT;
            if (item.value == 1) this.order.time = "1 tháng"
            if (item.value == 2) this.order.time = "3 tháng"
            if (item.value == 3) this.order.time = "12 tháng"
        },
        selectedPaymentType: function(item){
            this.optionPayments.forEach(el => el.selected = false);
            item.selected = item.value;
            this.valueSelectedPayment = item.value;
        },
        checkForm: function(){
            let check = false;

            if (!this.businessPackage.id) {
                check = true;
                return this.$vs.notify({
                    text: 'Chưa chọn gói dữ liệu',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    color: 'danger'
                })
            }
            if (check) return;
            
            let index = 0;
            this.optionalPackages.map(el => {
                if (!el.selected) {
                    index++;
                }
                if (index == 3) {
                    check = true;
                    return this.$vs.notify({
                        text: 'Chưa chọn gói dữ liệu',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather',
                        color: 'danger'
                    })
                }
            })
            if (check) return;

            let indexPayment = 0;
            this.optionPayments.map(el => {
                if (!el.selected){
                    indexPayment++;
                }
                if (indexPayment == 2){
                    check = true;
                    return this.$vs.notify({
                        text: 'Chưa chọn loại thanh toán',
                        icon: 'icon-alert-circle',
                        iconPack: 'feather',
                        color: 'danger'
                    })
                }
            })
            if (check) return;
            
            if (!this.invoice.acceptTerm) {
                check = true;
                return this.$vs.notify({
                    text: 'Chưa chấp nhận điều khoản từ InfoCare',
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    color: 'danger'
                })
            }
            if (check) return;
        },
        conver: function(n) { return n < 10 ? '0' + n : n; }, 
        randomInvoiceCode: function(){
            var randomNumber = Math.floor(Math.random() * (999999 -  100000)) + 100000;
            let d = new Date();
            randomNumber = this.conver(d.getDate()) + this.conver(d.getMonth()+1) + d.getFullYear() + random_num;var random_num = Math.floor(Math.random() * (999999 -  100000)) + 100000;
            randomNumber = this.conver(d.getDate()) + this.conver(d.getMonth()+1) + d.getFullYear() + random_num;
            return randomNumber;
        },
        saveChanges: function(){
            this.checkForm();
            this.order.code = this.randomInvoiceCode();
            const payload = {
                code: this.order.code,
                businessPackageId: this.businessPackage.id,
                totalPayment: this.order.total,
                paymentPeriodType: this.valueSelectedPackage,
                paymentType: this.valueSelectedPayment,
                allowNotify: this.invoice.allowNotify
            }
            this.$business.post('/user-package/create-invoice', payload).then(() => {
                this.$router.push('/user/v2/invoice');
            })
        },
        getBusinessPackage: function(){
            this.$business.get('business-package/all').then((res) => {
                let result = res.data;
                result = result.map(el => {
                    if (el.name.includes('Gói khởi động')) el.name = "Starter - Gói khởi động";
                    if (el.name.includes('Gói cơ bản')) el.name = "Basic - Gói cơ bản";
                    if (el.name.includes('Gói nâng cao')) el.name = "Plus - Gói nâng cao";
                    if (el.name.includes('Gói chuyên nghiệp')) el.name = "Pro - Gói chuyên nghiệp";
                    if (el.name.includes('Gói cao cấp')) el.name = "Premium - Gói cao cấp";
                    return {
                        name: el.name,
                        price: el.price,
                        id: el.id,
                        bg: null
                    }
                })
                this.businessPackages = result;
            })
        },
        chosePackage: function(item){
            this.businessPackage.id = item.id;
            this.businessPackage.name = item.name;
            this.businessPackage.price = item.price;
        },
        initScreen(){
            let dataUser = localStorage.getItem('userInfo');
            let user = JSON.parse(dataUser);
            if (user.id) {
            this.$vs.loading();
            this.$oauth.post('/user/find-by-condition/' + user.id).then((response) => {
                this.$vs.loading.close();
                this.districtOptions = province.getDistrict(response.data.city);
                this.subDistrictOptions = province.getSubDistrict(response.data.city, response.data.district);
                response.data.organizationName = response.data.organization ? response.data.organization.organizationName : "";
                this.user = response.data;
                this.valueSelectedSubject = response.data.customerType;
                // this.isUpdate = true;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
            });
            }
            this.getBusinessPackage();
        },
        eArabic: function(x) {
            return x.toLocaleString("de-DE");
        }
    },
    async created(){
        this.initScreen();
    }
}
</script>
<style scoped>
.font-label {
    font-size: 12px;
}
.bg-package {
    background: #2f80ec;
    color: white;
}
.text-title-package {
    color: #5E5873;
}
.text-discount {
    color: #28C76F;
    font-size: 12px;
}
.text-content {
    font-size: 12px;
    color: #B9B9C3;
}
.text-contact {
    color: #B9B9C3;
}
.border-bottom-color {
    border-bottom: 1px solid #D8D6DE;
    /* height: 35px; */
}
.text-suggest {
    color: #5E5873;
}
.margin-top {
    margin-top: -24px;
}
.bg-business-package {
    height: 100vh;
    z-index: 200000;
    position: fixed;
    top: 0px;
    padding-top: 100px;
    background: rgb(0, 0, 0, 0.2);
    left: 0;
    right:0;
}
</style>